/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
//  import wx from 'weixin-js-sdk'
//  let wx = require('weixin-js-sdk');
import wx from 'weixin-jsapi'
//  import Axios from 'axios'
const wxApi = {
     /**
      * [wxRegister 微信Api初始化]
      * @param  {Function} callback [ready回调函数]
      */
    wxRegister(data, option) {
        console.log(data);
        console.log(option);
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'updateTimelineShareData',
                'updateAppMessageShareData',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'wx-open-launch-weapp'
            ],
            openTagList: ['wx-open-launch-weapp']
        });
        var shareData = {
            imgUrl: option.imgUrl,
            link: option.link,
            desc: option.desc,
            title: option.title,
            success: function () {
                console.log('sharecallback')
                option.success()
            },
            fail: function () {
            //   alert('调用失败')
            },
            complete: function () {
            //   alert('调用结束')
            }
        };
        wx.ready(function() {
            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareAppMessage(shareData);
        });
        // wx.ready(function() {
        //     wx.updateTimelineShareData(shareData)
        //     wx.updateAppMessageShareData(shareData)
        // });
    }
}

export default wxApi